/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ParameterCombinationDto } from './ParameterCombinationDto';
import {
    ParameterCombinationDtoFromJSON,
    ParameterCombinationDtoFromJSONTyped,
    ParameterCombinationDtoToJSON,
} from './ParameterCombinationDto';

/**
 * 
 * @export
 * @interface GetTrackItMeasurementsDto
 */
export interface GetTrackItMeasurementsDto {
    /**
     * 
     * @type {ParameterCombinationDto}
     * @memberof GetTrackItMeasurementsDto
     */
    combination: ParameterCombinationDto;
    /**
     * 
     * @type {string}
     * @memberof GetTrackItMeasurementsDto
     */
    targetSystemTrackItAlias?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrackItMeasurementsDto
     */
    startTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrackItMeasurementsDto
     */
    endTime?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetTrackItMeasurementsDto
     */
    measurementIdsToExclude?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrackItMeasurementsDto
     */
    $type?: GetTrackItMeasurementsDtoTypeEnum;
}


/**
 * @export
 */
export const GetTrackItMeasurementsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoGetTrackItMeasurementsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.GetTrackItMeasurementsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetTrackItMeasurementsDtoTypeEnum = typeof GetTrackItMeasurementsDtoTypeEnum[keyof typeof GetTrackItMeasurementsDtoTypeEnum];



/**
 * Check if a given object implements the GetTrackItMeasurementsDto interface.
 */
export function instanceOfGetTrackItMeasurementsDto(value?: unknown): value is GetTrackItMeasurementsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetTrackItMeasurementsDtoTypeEnum)[0];
}

export function GetTrackItMeasurementsDtoFromJSON(json: any): GetTrackItMeasurementsDto {
    return GetTrackItMeasurementsDtoFromJSONTyped(json, false);
}

export function GetTrackItMeasurementsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTrackItMeasurementsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'combination': ParameterCombinationDtoFromJSON(json['combination']),
        'targetSystemTrackItAlias': json['targetSystemTrackItAlias'] == null ? undefined : json['targetSystemTrackItAlias'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'measurementIdsToExclude': json['measurementIdsToExclude'] == null ? undefined : json['measurementIdsToExclude'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function GetTrackItMeasurementsDtoToJSON(value?: GetTrackItMeasurementsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'combination': ParameterCombinationDtoToJSON(value['combination']),
        'targetSystemTrackItAlias': value['targetSystemTrackItAlias'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'measurementIdsToExclude': value['measurementIdsToExclude'],
        '$type': value['$type'],
    });
}

